import React, { forwardRef, useEffect, useState } from "react";

import { StyledInputWrapper } from "./inputOtherField.style";
import GenericInputField, {
  TYPES,
  Label,
} from "../../../genericInputFields/genericInputField";
import { useWatch } from "react-hook-form";
import useSolutionForm from "../../../../hooks/useSolutionForm";

const keyWords = ["other", "Other", "OTHER", "Other Reason", "Other reason"];

const InputOtherField = forwardRef(({ data, name, error, index }, ref) => {
  const { id, title, placeholder, maxCharacters, restricted } = data;
  const {
    formMethods: { register, control, setValue },
    disableRestrictedFields,
  } = useSolutionForm();

  const [showField, setShowField] = useState(false);

  const watchingName = `solution.supplemental_submission_answers.${index - 1}.answer`;
  const watchPreviousField = useWatch({ control, name: watchingName });

  useEffect(() => {
    if (typeof watchPreviousField === "undefined") return;
    setShowField(keyWords.includes(watchPreviousField));
    if (!keyWords.includes(watchPreviousField)) {
      setValue(`${name}.answer`, "");
    }
  }, [watchPreviousField]);

  if (!showField) {
    return null;
  }
  return (
    <StyledInputWrapper ref={ref}>
      <input
        type="hidden"
        value={id}
        {...register(`${name}.supplemental_submission_field_id`)}
      />
      <Label required={showField}>{title}</Label>
      <GenericInputField
        type={TYPES.SIMPLE_TEXT}
        register={register}
        name={`${name}.answer`}
        required={showField}
        placeholder={placeholder}
        maxCharacters={maxCharacters}
        readOnly={restricted && disableRestrictedFields}
        error={error}
      />
    </StyledInputWrapper>
  );
});
InputOtherField.displayName = "InputOtherField";

export default InputOtherField;
